var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('v-img',{staticClass:"rounded-loader",attrs:{"alt":"Loading GIF","src":"https://pa1.narvii.com/6597/465e7ff652957e7b7baa82460459d77ca7145b63_hq.gif","contain":"","width":"90%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }